export const getBitValueFromBool = (value: boolean): '1' | '0' => {
	return Number(value).toString() as '1' | '0';
};

export const getBoolFromBitValue = (bitValue?: string) => {
	if (bitValue) {
		return !!Number(bitValue as '1' | '0');
	}
};
